import { $, freeze } from '../utils/Utils';

const navMobile = (() => {
  const trigger = $('.js-navMobileTrigger')[0];

  const handleResize = () => {
    if (window.innerWidth > 768) {
      trigger.checked = false;
      unwatchResize();
    }
  };

  const unwatchResize = () => {
    window.removeEventListener('resize', handleResize);
  };

  const watchResize = () => {
    window.addEventListener('resize', handleResize);
  };

  const handleClick = () => {
    trigger.addEventListener('change', () => {
      if (trigger.checked) {
        window.scrollTo(0, 0);
        freeze.start();
        watchResize();
      } else {
        freeze.stop();
      }
    });
  };

  const build = () => {
    handleClick();
  };

  const init = () => {
    if (trigger) {
      build();
    }
  };

  return {
    init,
  };
})();

export default navMobile.init();



// WEBPACK FOOTER //
// ./components/nav-mobile.js